import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import { ASSIGNMENTS_AGENDA_MOUNTED, FETCH_ASSIGNMENTS_SUCCESS } from "./actions"
import { ACCOUNT_SELECTED, REFETCH_DATA } from "../../auth/actions"
import type { Assignment } from "../../../graphql/types"
import { ASSIGNMENT_CREATED, ASSIGNMENT_DELETED, ASSIGNMENT_UPDATED } from "../../data/actions"
import { LOCATION_INITIALIZED, LOCATION_SELECTED } from "../../common/locationsPicker/actions"

export type AssignmentsState = {
    assignments: Maybe<Assignment[]>
}

export const createDefaultAssignmentsState = () => ({
    assignments: null,
})
export const assignmentsReducer = (state: Maybe<AssignmentsState> = undefined, action: Record<string, any>) => {
    if (!state) {
        return createDefaultAssignmentsState()
    }

    switch (action.type) {
        case ACCOUNT_SELECTED:
        case REFETCH_DATA:
        case ASSIGNMENTS_AGENDA_MOUNTED:
        case LOCATION_INITIALIZED:
        case LOCATION_SELECTED:
            return createDefaultAssignmentsState()

        case FETCH_ASSIGNMENTS_SUCCESS:
            return { ...state, assignments: action.payload.assignments }

        case ASSIGNMENT_CREATED: {
            if (action.payload.assignment.parentId == null) {
                return { ...state, assignments: [...(state.assignments || []), action.payload.assignment] }
            } else {
                return {
                    ...state,

                    assignments: (state.assignments || []).map(a =>
                        a.id !== action.payload.assignment.parentId
                            ? a
                            : {
                                  ...a,
                                  children: a.children
                                      ? [...a.children, action.payload.assignment]
                                      : [action.payload.assignment],
                              }
                    ),
                }
            }
        }

        case ASSIGNMENT_UPDATED: {
            // If assignment
            if (action.payload.newValue.parentId != null) {
                const filtered = (state.assignments || []).map(a => {
                    return {
                        ...a,
                        children: a.children ? a.children.filter(ch => ch.id !== action.payload.newValue.id) : [],
                    }
                })
                const adjusted = filtered.map(a =>
                    a.id !== action.payload.newValue.parentId
                        ? a
                        : {
                              ...a,
                              children: a.children
                                  ? [...a.children, action.payload.newValue]
                                  : [action.payload.assignment],
                          }
                )
                return { ...state, assignments: [...adjusted] }
            }

            return {
                ...state,

                assignments: (state.assignments || []).map(section =>
                    section.id !== action.payload.newValue.id
                        ? section
                        : {
                              ...section,
                              ...action.payload.newValue,
                              children:
                                  section.children &&
                                  section.children.map(ch =>
                                      ch.parentId !== action.payload.newValue.id
                                          ? ch
                                          : { ...ch, config: action.payload.newValue.config }
                                  ),
                          }
                ),
            }
        }

        case ASSIGNMENT_DELETED: {
            return {
                ...state,

                assignments: (state.assignments || [])
                    .map(a =>
                        a.id !== action.payload.assignmentId
                            ? {
                                  ...a,
                                  children:
                                      a.children &&
                                      a.children
                                          .map(ch => (ch.id !== action.payload.assignmentId ? ch : null))
                                          .filter(b => b),
                              }
                            : null
                    )
                    .filter(a => a),
            }
        }

        default:
            return state
    }
}
